// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__WuqFq","footer":"ModalError_footer__3lyuN"};